import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49017364"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold m-confirmation-dialog" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Waiting for confirmation…", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Confirm this transaction in your wallet to continue.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "spinner" }, null, -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Your transaction has been submitted.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your transaction is being confirmed on the Ethereum blockchain.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "spinner" }, null, -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Your transaction has confirmed.", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your tokens will be revealed shortly.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Revealing...", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "spinner" }, null, -1))
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Error", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "There was a problem submitting your transaction.", -1))
const _hoisted_21 = { key: 0 }

import { computed } from "vue";
import { RevealingState, TransactionState } from "@manifoldxyz/collectible-sdk";
import { EthereumNetwork } from "@manifoldxyz/frontend-provider-types";
import { EthereumProvider } from "@/EthereumProvider";


export default /*#__PURE__*/_defineComponent({
  __name: 'PendingTransactionDialog',
  props: {
    transactionState: {}
  },
  emits: ["reset"],
  setup(__props: any, { emit }) {

const props = __props;



const etherscanUrl = computed(() => {
  let baseUrl = "";

  if (EthereumProvider.network() === EthereumNetwork.MAINNET) {
    baseUrl = `https://etherscan.io/tx`;
  } else if (EthereumProvider.network() === EthereumNetwork.GOERLI) {
    baseUrl = `https://goerli.etherscan.io/tx`;
  }
  const txHash = (props.transactionState as RevealingState).data?.transactionHash;

  return baseUrl && txHash ? `${baseUrl}/${txHash}` : "#";
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const errorMessage = computed(() => {
  if (props.transactionState.status !== "Error") {
    return "";
  }

  const { error, errorMessage } = props.transactionState.data;

  return errorMessage || error;
});

const onClose = () => {
  emit("reset");
};
const isAwaitingSignature = computed(
  () => props.transactionState?.status === "AwaitingSignature" || !props.transactionState
);
const isSubmitting = computed(() => props.transactionState?.status === "Mining");
const isRevealing = computed(() => props.transactionState?.status === "Revealing");
const isError = computed(() => props.transactionState?.status === "Error");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isAwaitingSignature.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
          : (isSubmitting.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("a", {
                  href: etherscanUrl.value,
                  target: "_blank"
                }, "View on Etherscan", 8, _hoisted_11)
              ]))
            : (isRevealing.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _createElementVNode("a", {
                    href: etherscanUrl.value,
                    target: "_blank"
                  }, "View on Etherscan", 8, _hoisted_17)
                ]))
              : (isError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", null, [
                      _hoisted_20,
                      (errorMessage.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Reason: " + _toDisplayString(errorMessage.value), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("button", { onClick: onClose }, "Try Again")
                  ]))
                : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})